import type { QueryClient } from "@tanstack/react-query";

/** After a sync: refresh profile-contacts, and by default the job's pipeline
 *  candidates. Accept may pass `{ pipeline: false }` (HTTP accept only creates
 *  the SyncJob — no enroll yet; pipeline bust is redundant and races first SSE).
 *  Toast terminal keeps the full bust. Credit balance updates via notification
 *  `credit_changed` (or reveal setQueryData); do not refetch /credits here. */
export function invalidateAfterSync(
  queryClient: QueryClient,
  jobId: string,
  opts?: { pipeline?: boolean },
): void {
  if (opts?.pipeline !== false) {
    queryClient.invalidateQueries({ queryKey: ["pipeline", jobId] });
  }
  queryClient.invalidateQueries({ queryKey: ["profile-contacts"] });
}

/** After a stage move/advance/archive: bust the Sync modal's preflight cache
 *  for this job. A candidate's syncability (e.g. `in_sourced` vs `syncable`)
 *  depends on its current stage, so a move can flip it — without this, the
 *  modal can show a stale preflight for up to `staleTime` after the move. */
export function invalidateSyncPreflight(queryClient: QueryClient, jobId: string): void {
  queryClient.invalidateQueries({ queryKey: ["sync-preflight", jobId] });
}
